import React from 'react';
import {DeviceViewModel} from "../../../../core/models/device.view-model";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {
  PreviousMeetingsWidgetGamePlaceholder
} from "../../../previous-meetings-widget/components/placeholders/previous-meetings-widget.game.placeholder";

export class RecentFormWidgetFullPlaceholderComponentProps extends BaseProps {
  device: DeviceViewModel;
  style: Object;
}

export const RecentFormWidgetFullPlaceholder = (props: RecentFormWidgetFullPlaceholderComponentProps) => {
  const games: Array<Object> = [];

  for (let i = 0; i < 5; i++) {
    games.push({
      key: i,
    });
  }

  return (
    <div
      className={['recent-form-widget-full-placeholder-container', props.device.isSmallView ? 'recent-form-widget-full-placeholder-small-view' : ''].join(' ')}>
      <div className={'recent-form-widget-full-placeholder-competitor'}>
        {
          games.map((game) => <PreviousMeetingsWidgetGamePlaceholder isRecentForm={true} key={game.key} {...props}/>)
        }
      </div>
      <div className={'recent-form-widget-full-placeholder-competitor'}>
        {
          games.map((game) => <PreviousMeetingsWidgetGamePlaceholder isRecentForm={true} key={game.key} {...props}/>)
        }
      </div>
    </div>
  )
}
